import React from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { DisclosureBanner } from "../components/DisclosureBanner";
import { LegalLayout } from "./LegalLayout";
import { useLegalSEO } from "../lib/useLegalSEO";

const Terms = () => {
    useLegalSEO({
        title: "Terms of Use | Better Rest Report",
        description:
            "Terms of Use for SleepComfortReport.com — editorial purpose, affiliate relationships, warranty, and use of the site.",
        path: "/terms",
    });
    return (
    <div className="App">
        <DisclosureBanner variant="top" />
        <Header />
        <LegalLayout
            kicker="Legal"
            title="Terms of Use"
            updated="Last updated: December 2025"
            testId="page-terms"
        >
            <p>
                These Terms of Use ("Terms") govern your access to and use of
                SleepComfortReport.com (the "Site"). By accessing or using
                the Site, you agree to be bound by these Terms. If you do
                not agree, please do not use the Site.
            </p>

            <h2>1. Editorial & Informational Use Only</h2>
            <p>
                The content published on the Site is for general
                informational and editorial purposes only. It does not
                constitute medical, legal, financial, or professional
                advice. Nothing on this Site is intended to diagnose, treat,
                cure, or prevent any disease or health condition. Always
                consult a qualified professional for any concerns relating
                to your health.
            </p>

            <h2>2. Affiliate Relationships</h2>
            <p>
                The Site participates in affiliate programs, including the
                ClickBank affiliate network. We may receive a commission
                when you click affiliate links and complete a qualifying
                purchase at no additional cost to you. Our editorial
                opinions are our own and are not influenced by these
                commissions.
            </p>

            <h2>3. No Warranty</h2>
            <p>
                The Site and all content are provided on an "as is" and "as
                available" basis without warranties of any kind, either
                express or implied. We do not guarantee any specific results
                from using any product mentioned on the Site.
            </p>

            <h2>4. Third-Party Products & Links</h2>
            <p>
                The Site may include links to third-party websites, products,
                and services that are not owned or controlled by us. We are
                not responsible for the content, privacy practices, or
                business practices of any third-party site, and we encourage
                you to read the terms and policies of any third-party site
                you visit.
            </p>

            <h2>5. Intellectual Property</h2>
            <p>
                All content on the Site — including text, graphics, logos,
                images, and the overall design — is the property of
                SleepComfortReport.com or its content partners and is
                protected by applicable intellectual property laws. You may
                not reproduce, distribute, or create derivative works
                without our prior written permission.
            </p>

            <h2>6. User Conduct</h2>
            <p>
                You agree not to use the Site for any unlawful purpose, to
                attempt to gain unauthorized access to any portion of the
                Site, to interfere with the operation of the Site, or to
                engage in any activity that could harm the Site or other
                users.
            </p>

            <h2>7. Limitation of Liability</h2>
            <p>
                To the maximum extent permitted by law, SleepComfortReport.com
                and its affiliates shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages
                arising from your use of the Site, even if advised of the
                possibility of such damages.
            </p>

            <h2>8. Modifications</h2>
            <p>
                We reserve the right to modify these Terms at any time. Your
                continued use of the Site after such changes constitutes
                acceptance of the modified Terms.
            </p>

            <h2>9. Governing Law</h2>
            <p>
                These Terms are governed by the laws of the United States
                and the State of Delaware, without regard to its conflict of
                laws principles.
            </p>

            <h2>10. Contact</h2>
            <p>
                For questions about these Terms, please use our{" "}
                <a href="/contact">Contact</a> page.
            </p>
        </LegalLayout>
        <Footer />
    </div>
    );
};

export default Terms;
